import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Component } from 'react';
import { ConnectedRouter } from 'react-router-redux';
import { Route, Switch, Redirect } from 'react-router';
import ErrorPage from '../pages/ErrorPage';
import LoginPage from '../pages/LoginPage';
import LogoutPage from '../pages/LogoutPage';
import HomePage from '../pages/HomePage';
import RepositoriesPage from '../pages/RepositoriesPage';
import RepositoryPage from '../pages/RepositoryPage';
import { defaultUrl as repositoryUrl } from '../pages/RepositoryPage/components/RepositoryDetail';
import CommitPage from '../pages/CommitPage';
import PullRequestPage from '../pages/PullRequestPage';
import PullRequestsPage from '../pages/PullRequestsPage';
import RepositorySettingsPage from '../pages/RepositorySettingsPage';
import SettingsPage, { defaultUrl as settingsUrl } from '../pages/SettingsPage';
import VelocityReportPage from '../pages/VelocityReportPage';
export const repositoriesRoutes = [
    {
        path: repositoryUrl + '/commits',
        component: RepositoryPage,
    },
    {
        path: repositoryUrl + '/pull-requests',
        component: PullRequestsPage,
    },
    {
        path: repositoryUrl + '/pull-requests/:id/:filterFirst?/:filterSecond?',
        component: PullRequestPage,
    },
    {
        path: repositoryUrl + '/settings',
        component: RepositorySettingsPage,
    },
    {
        path: repositoryUrl + '/:branch?',
        component: RepositoryPage,
    },
    {
        path: repositoryUrl + '/:branch?/commits',
        component: RepositoryPage,
    },
    {
        path: repositoryUrl + '/:branch?/commits/:hash/:filterFirst?/:filterSecond?',
        component: CommitPage,
    },
];
const routes = [
    {
        path: '/',
        component: HomePage,
    },
    {
        path: '/login',
        component: LoginPage,
    },
    {
        path: '/repositories',
        component: RepositoriesPage,
    },
    {
        path: '/velocity-report',
        component: VelocityReportPage,
    },
    {
        path: '/logout',
        component: LogoutPage,
    },
    ...repositoriesRoutes,
    ...repositoriesRoutes.map((route) => ({
        ...route,
        path: route.path.replace(repositoryUrl, repositoryUrl + '/:subrepository'),
    })),
    {
        path: '/index.html',
        component: HomePage,
    },
];
export default class RootRouter extends Component {
    render() {
        const { history } = this.props;
        return (_jsx(ConnectedRouter, { history: history, children: _jsxs(Switch, { children: [_jsx(Route, { exact: true, path: "/login/:slug", render: (props) => _jsx(LoginPage, { ...this.props, ...props }) }), _jsx(Route, { exact: true, path: "/pull-requests", render: () => _jsx(Redirect, { to: `/velocity-report` }) }), _jsx(Route, { path: settingsUrl, component: SettingsPage }), _jsx(Route, { exact: true, path: "/:owner/:repository", render: (props) => (_jsx(Redirect, { to: `/bitbucket/${props.match.params.owner}/${props.match.params.repository}` })) }), _jsx(Route, { exact: true, path: "/:owner/:repository/commits", render: (props) => (_jsx(Redirect, { to: `/bitbucket/${props.match.params.owner}/${props.match.params.repository}/commits` })) }), _jsx(Route, { exact: true, path: "/:owner/:repository/commits/:hash", render: (props) => (_jsx(Redirect, { to: `/bitbucket/${props.match.params.owner}/${props.match.params.repository}/commits/${props.match.params.hash}` })) }), routes.map((route, i) => (_jsx(Route, { exact: true, path: route.path, render: (props) => _jsx(route.component, { ...this.props, ...props }) }, i))), _jsx(Route, { render: (props) => {
                            // @ts-expect-error TS2769: No overload matches this call.
                            return _jsx(ErrorPage, { ...this.props, ...props });
                        } })] }) }));
    }
}
